import { render, staticRenderFns } from "./BlackGoldWithdrawAvailableModal.vue?vue&type=template&id=36c92802"
import script from "./BlackGoldWithdrawAvailableModal.vue?vue&type=script&lang=js"
export * from "./BlackGoldWithdrawAvailableModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports